// extracted by mini-css-extract-plugin
module.exports = {"newsDate":"latest-news-module--newsDate--2Y8LT","newsName":"latest-news-module--newsName--IoL5T","container":"latest-news-module--container--2E9sY"};